/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { Select } from '../../../design-system/atoms/Select/Select';
import { Input } from '../../../design-system/atoms/Input/Input';
import { Button } from '../../../design-system/atoms/Button/Button';
import { Pagination } from '../../../design-system/molecules/Pagination/Pagination';
import { Cluster } from '../../../design-system/layout/Cluster';
import { separatorStyle, searchStyle } from './DataBrowserToolbar.styles';

export interface DataBrowserToolbarProps {
  moduleValue: string;
  moduleOptions: string[];
  onChangeModule: (v: string) => void;
  tableValue: string;
  tableOptions: { label: string; value: string }[];
  onChangeTable: (v: string) => void;
  searchText: string;
  onSearchChange: (v: string) => void;
  onAddColumnFilter?: () => void;
  /** 전체 건수 문구. 예: "128,540 rows" */
  totalLabel?: ReactNode;
  /** 현재 범위 문구. 예: "1–50" */
  rangeLabel: ReactNode;
  onPrev?: () => void;
  onNext?: () => void;
}

const toOptions = (list: string[]) => list.map((o) => ({ label: o, value: o }));

/** 데이터 브라우저 도구줄. 모듈/테이블 선택, 검색, 행 탐색에 활용. */
export function DataBrowserToolbar({
  moduleValue,
  moduleOptions,
  onChangeModule,
  tableValue,
  tableOptions,
  onChangeTable,
  searchText,
  onSearchChange,
  onAddColumnFilter,
  totalLabel,
  rangeLabel,
  onPrev,
  onNext,
}: DataBrowserToolbarProps) {
  return (
    <Cluster gap="sm" justify="between">
      <Cluster gap="sm">
        <Select options={toOptions(moduleOptions)} value={moduleValue} onChange={onChangeModule} />
        <span css={separatorStyle}>/</span>
        <Select options={tableOptions} value={tableValue} onChange={onChangeTable} />
        <span css={searchStyle}>
          <Input placeholder="전체 컬럼 텍스트 검색…" value={searchText} onChange={onSearchChange} />
        </span>
        <Button variant="outline" tone="neutral" onClick={onAddColumnFilter}>
          + 컬럼 필터
        </Button>
      </Cluster>
      <Pagination totalLabel={totalLabel} rangeLabel={rangeLabel} onPrev={onPrev} onNext={onNext} />
    </Cluster>
  );
}
